import React from 'react';
import styled from 'styled-components';
import { CircularProgress } from '@mui/material';

const LoaderContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 9999;
`;

const LoaderText = styled.div`
  margin-top: 20px;
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  color: #333;
`;

const Loader = ({ customText = 'Loading...' }) => {
  return (
    <LoaderContainer>
      <CircularProgress />
      <LoaderText>{customText}</LoaderText>
    </LoaderContainer>
  );
};

export default Loader; 